import { Dispatch } from '@reduxjs/toolkit';
import {connect} from "react-redux";

import {LanguageProviderContainer} from "../view/view";
//import { requestUserCreationFromAPI } from '../thunk/request_func';
import { RootState } from '../../../app/store';
import { languageActions } from '../actions/LanguageAction';

interface OwnProps {
    id:string;
}

//TODO: GREGOR QUEastion, why does it cry for a language varaible???
function mapStateToProps(state:RootState, ownProps:OwnProps){
    // state:rootState includes all global variables as state
    const myprops=
    {
        id:"",
        language:state.language.model.language,
    }
    // Return the whole construct to the container itself
    return myprops;
    // NEVER Add ACtions or Functions here
}



function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLanguageChange:()=>{ 
            dispatch(languageActions.toggleLanguage({}));
        },

    }
}

const MyLanguageProviderContainer=connect(mapStateToProps, bindDispatchToActions)(LanguageProviderContainer);
export default MyLanguageProviderContainer;